import React from "react";
import { Tabs } from 'antd';

import './Configuration.css';
import Profile from "./Profile";
import Password from "./Password";
import Report from "./Report";


// Props
interface Pros {
    setVisibleConf: React.Dispatch<React.SetStateAction<boolean>>;
    setAskBeforeClosing: React.Dispatch<React.SetStateAction<boolean>>;
}

// Options Tabs
const { TabPane } = Tabs;

const Configuration: React.FC<Pros> = ({ setVisibleConf, setAskBeforeClosing }) => {

    return (
        <Tabs className="configuration" tabPosition={'left'}>
            <TabPane tab="Perfil" key="1">
                <Profile setAskBeforeClosing={setAskBeforeClosing} />
            </TabPane>
            <TabPane tab="Contraseña" key="2">
                <Password setVisibleConf={setVisibleConf} />
            </TabPane>
            <TabPane tab="Reportar" key="3">
                <Report setVisibleConf={setVisibleConf} />
            </TabPane>
        </Tabs>
    );
}

export default Configuration;